module.exports = __webpack_public_path__ + "img/securitydetailsList4.7b1cd652.png";